import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { MULTIMEDIA_MANAGER_SEARCH_BLOCK_HEIGHT } from '../MultimediaSearch/styles';
import { MULTIMEDIA_MANAGER_TABS_WIDTH } from '../MultimediaTabs/styles';

export const useStyles = makeStyles<Theme>((theme) => ({
  headerText: () => ({
    left: `${MULTIMEDIA_MANAGER_TABS_WIDTH}px`,
    top: `calc(${MULTIMEDIA_MANAGER_SEARCH_BLOCK_HEIGHT}px + ${theme.spacing(
      4,
    )})`,
    zIndex: 2,
    backgroundColor: theme.palette.grey[100],
  }),
  dialogContent: {
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    left: 0,
    overflowY: 'auto',
    padding: 0,
    right: 0,
    top: 0,
  },
  dialogPaper: {
    maxHeight: '100%',
  },
  innerWrapper: {
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    maxWidth: '1100px',
    minHeight: '80vh',
    width: `calc(100vw - (${theme.spacing(4)} * 2))`,
    zIndex: 1,
  },
  multiMediaListHeaderTitle: {
    color: theme.palette.common.black,
    fontWeight: 500,
    textTransform: 'uppercase',
  },
}));
